export default __webpack_public_path__ + "static/media/treinamento.269b1575.png";